import React from 'react';
import Navbar from '../components/layout/Navbar';
import AddContactForm from '../components/layout/AddContactForm';

function AddContactPage() {
  return (
    <div>
      <Navbar />
      <div className='container'>
        <br />
        <h2>Add a Contact</h2>
        <AddContactForm />
      </div>
    </div>
  );
}

export default AddContactPage;
